<template>
  <div class="form-group" :class="{ row : isOnModeLabelOnLeft }">
    <label
      :for="idComputed"
      :title="titleComputed"
      :class=" {'col-sm-2': isOnModeLabelOnLeft, 'col-form-label': isOnModeLabelOnLeft }"
      class="text-truncate"
      >{{label}} <small v-if="required">*</small></label>
    <div :class="{ 'col-sm-10 input-group mb-2': isOnModeLabelOnLeft, 'input-group mb-2': !isOnModeLabelOnLeft }">
      <div class="input-group-prepend">
        <div class="input-group-text"><font-awesome-icon :icon="icon"/></div>
      </div>
      <input
        :value="value"
        @keyup.enter.exact="$emit('enter')"
        @input="$emit('input', $event.target.value)"
        @focusout="validateOnfocusOutMethod"
        class="form-control"
        :class="{'is-invalid': v.$error}"
        :readonly="readonly"
        :placeholder="placeholder"
        type="text"
        :id="idComputed"
        :disabled="disabled"
        />
      <p class="invalid-feedback" v-if="!v.isValid"> {{ $t('field_invalid')}} </p>
      <p class="invalid-feedback" v-else-if="!v.required"> {{ $t('field_required')}} </p>
    </div>
  </div>
</template>

<script>
import lmInputMixin from '@/mixins/lmInputMixin.js'
export default {
  mixins: [lmInputMixin],
  props: {
    icon: {
      type: String,
      default: 'search'
    }
  }
}
</script>
